module.exports = __webpack_public_path__ + "static/media/bank-account-bg.886bd144.svg";